module.exports = __webpack_public_path__ + "img/obt-step.4c1a8dcb.png";